import React, { Component } from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { formatMessage } from '../../lib/intl';
import mailSuccess from '../../img/mail-success.png';

const i18n = defineMessages({
  sent: {
    id: 'invitePeople.confirmation.sent',
    defaultMessage: 'Invitations successfully sent',
  },
});

export class InviteConfirmation extends Component {
  constructor(props) {
    super(props);
    this.formatMessage = formatMessage(this.props.intl);
  }

  render() {
    return (
      <div className="invite-confirmation container">
        <h2 className="text-center">
          <FormattedMessage
            id="invitePeople.confirmation.title"
            defaultMessage="Invitations Sent"
          />
        </h2>
        <p className="cool-grey text-center">
          <FormattedMessage
            id="invitePeople.confirmation.text"
            defaultMessage="Nice! Your invites were successfully sent."
          />
        </p>
        <div className="image-container text-center">
          <img src={mailSuccess} alt={this.formatMessage(i18n.sent)} />
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <button
              type="button"
              className="dashboard btn btn-primary mx-auto"
              onClick={this.props.closeModal}
            >
              <FormattedMessage
                id="invitePeople.confirmation.backButton"
                defaultMessage="Back to dashboard"
              />
            </button>
          </div>
        </div>
        <div className="row">
          <div className="col-12 text-center">
            <button type="button" className="send-invites btn mx-auto" onClick={this.props.showInvitePeopleModal}>
              <FormattedMessage
                id="invitePeople.confirmation.sendMore"
                defaultMessage="Send more invites"
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(InviteConfirmation);



// WEBPACK FOOTER //
// ./src/desktop/components/invite-people/invite-confirmation.js